import {
  CTA,
  TokenTextAppearance,
  TextTag,
} from '@volkswagen-onehub/components-core';
import { type ReactNode } from 'react';
import {
  CTAWrapper,
  CarViewImage,
  CarViewImageWrapper,
  DisabledMessage,
  TextSummary,
} from './VehicleCard.styles';

interface VehicleCardCarProps {
  disabled?: boolean;
  isMobileWidth: boolean;
  collapsed?: boolean;
  carSummary: ReactNode;
  disabledMessage: ReactNode;
  image: {
    url: string;
    alt: string;
  };
  cta: {
    text: ReactNode;
    onClick: () => void;
  };
}

const VehicleCardCar = ({
  disabled,
  isMobileWidth,
  collapsed,
  carSummary,
  disabledMessage,
  image,
  cta,
}: VehicleCardCarProps) => {
  return (
    <>
      <TextSummary
        disabled={disabled}
        appearance={
          collapsed && isMobileWidth
            ? TokenTextAppearance.copy100
            : TokenTextAppearance.copy200
        }
      >
        {carSummary}
      </TextSummary>
      {!collapsed && (
        <>
          <CarViewImageWrapper>
            <CarViewImage
              src={image.url}
              alt={image.alt}
              width="844"
              height="474"
              objectFit="contain"
            />
            {disabledMessage && (
              <DisabledMessage
                appearance={
                  isMobileWidth
                    ? TokenTextAppearance.headline200
                    : TokenTextAppearance.headline200
                }
                tag={TextTag.p}
                bold
              >
                {disabledMessage}
              </DisabledMessage>
            )}
          </CarViewImageWrapper>

          {!disabled && (
            <CTAWrapper>
              <CTA
                tag="button"
                emphasis="secondary"
                size={isMobileWidth ? 'small' : 'large'}
                onClick={cta.onClick}
              >
                {cta.text}
              </CTA>
            </CTAWrapper>
          )}
        </>
      )}
    </>
  );
};

export default VehicleCardCar;
